import { useState, useEffect } from "react";
import { useAdmin } from "@/contexts/AdminContext";
import { Link } from "react-router-dom";
import { Globe, Edit2 } from "lucide-react";

export default function AdminPages() {
  const { api } = useAdmin();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    api.get("/pages").then(r => setPages(r.data)).catch(() => {});
  }, []);

  const pageLabels = { home: "Home", about: "About", services: "Services", sectors: "Sectors", international: "International", contact: "Contact" };

  return (
    <div data-testid="admin-pages">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-heading text-2xl text-[#0A1628] font-medium">Pages</h1>
      </div>
      <p className="text-slate-500 text-sm mb-6">Edit headings, body text, images, and call-to-action buttons for each page section.</p>
      <div className="space-y-3">
        {pages.map(p => (
          <Link key={p.page_slug} to={`/admin/pages/${p.page_slug}`} data-testid={`page-link-${p.page_slug}`} className="bg-white border border-slate-200 p-5 rounded-[2px] flex items-center justify-between hover:border-[#0A1628] transition-colors block">
            <div className="flex items-center gap-4">
              <Globe size={18} className="text-[#C5A059]" />
              <div>
                <p className="text-[#0A1628] font-medium text-sm">{pageLabels[p.page_slug] || p.page_slug}</p>
                <p className="text-slate-400 text-xs">{p.section_count} sections</p>
              </div>
            </div>
            <Edit2 size={14} className="text-slate-400" />
          </Link>
        ))}
        {pages.length === 0 && <p className="text-slate-400 text-sm text-center py-8">No pages configured yet. Run seed to initialize.</p>}
      </div>
    </div>
  );
}
